// extracted by mini-css-extract-plugin
export var section = "styles-module--section--lVjkd";
export var tagline = "styles-module--tagline--t8hv1";
export var content = "styles-module--content--bBzO5";
export var title = "styles-module--title--YkDlM";
export var backAndForthRight = "styles-module--backAndForthRight--kp67t";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--aAGJD";
export var animateBg = "styles-module--animateBg--T3Wnz";